/* eslint-disable max-len */

import { variables } from 'components/theme';
import { bodyBackgroundColor } from 'utils/theme';
import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    @font-face {
        font-weight: 200;
        font-family: 'MTNBrighterSans';
        src: url('fonts/MTNBrighterSans-ExtraLight.woff') format('woff');
    }

    @font-face {
        font-weight: 300; 
        font-family: 'MTNBrighterSans';
        src: url('fonts/MTNBrighterSans-Light.woff') format('woff');
    }

    @font-face {
        font-weight: 500; 
        font-family: 'MTNBrighterSans';
        src: url('fonts/MTNBrighterSans-Medium.woff') format('woff');
    }

    @font-face {
        font-weight: bold;
        font-family: 'MTNBrighterSans';
        src: url('fonts/MTNBrighterSans-Bold.woff') format('woff');
    }

    @font-face {
        font-weight: 800; 
        font-family: 'MTNBrighterSans';
        src: url('fonts/MTNBrighterSans-ExtraBold.woff') format('woff');
    }

    @font-face {
        font-weight: normal;
        font-family: 'MTNBrighterSans';
        src: url('fonts/MTNBrighterSans-Regular.woff') format('woff');
    }

  body.fontLoaded {
    font-family: MTNBrighterSans, sans-serif, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', Helvetica, Arial;
  }

  html,
  body {
    height: 100vh;
    width: 100%;
    line-height: 1.9;
    margin: 0;
    padding: 0;
    font-size: 14px;
    scroll-behavior: smooth;
    background: ${bodyBackgroundColor};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  .ReactModal__Body--open {
    position: static;
    /* overflow-y: scroll; */
  }

  .ReactModal__Html--open {
    overflow-y: hidden;
  }

  .ReactModalPortal {
    position: fixed;
    z-index: 500;
  }
  };

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  };

  :focus {
    outline: none;
  };

  *::selection {
    background: #faea28 !important;
    color: #31383E;
  }

  h1, h2, h3, h4, h5, h6, label {
    font-weight: bold;
    font-family: MTNBrighterSans, sans-serif;
  }
  
  p {
    font-family: MTNBrighterSans, sans-serif;
  }

  h1 {
    font-size: 2.25em;
  }

  h2 {
    font-size: 1.875em;
  }

  h3 {
    font-size: 1.5em;
    line-height: 26px;
  }

  h4 {
    font-size: 18px;
  }

  h5 {
    font-size: 1em;
  }

  h6 {
    font-size: 0.875em;
    margin-bottom: 0;
  }

  strong {
    color: #31383e;
  }

  a {
    cursor: pointer;
    font-size: 14px;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-family: MTNBrighterSans, sans-serif;
}

  button {
    cursor: pointer;
    font-weight: 600;
    cursor: pointer;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-family: MTNBrighterSans, sans-serif;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  }

  input {
    font-family: 'MTNBrighterSans', sans-serif;
  }

  input:-internal-autofill-selected {
    background-color: rgba(250, 234, 41, .1) !important;
    color: #31383E !important;
  }

  /* Change Autocomplete styles in Chrome*/
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    border: 1px solid ${variables.colors.gray7};
    -webkit-text-fill-color: ${variables.colors.grey4};
    box-shadow: 0 0 0px 1000px rgba(250, 234, 41, 0.05) inset;
    transition: background-color 3000s ease-in-out 0s;
  }

  o:p {
    display: none !important;
  }
    .hero-card .ant-card-body{
    padding:0 !important;
    }

    .chan-hero-button button{
    width:100% !important;
    height:50px
  
    }
`;

export default GlobalStyle;
